import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../../components/Navbar";
import {
  Search,
  Download,
  UserPlus,
  Users,
  UserCheck,
  UserX,
  Filter,
  Plus,
} from "lucide-react";
import SenderTableComponent from "../../components/Senders/SenderTableComponent";
import {
  fetchSenders,
  fetchSenderStats,
} from "../../requests/Sender_Ids/SenderService";
import ShimmerTableComponent from "../../components/ShimmerTableComponent";
import SenderIdShimmerComponent from "../../components/Senders/SenderIdShimmerComponent";
import StatCard from "../../components/Senders/StatCard";
import LoadErrorPlaceholder from "../../components/LoadErrorPlaceholder";

const Senders = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [selectedRows, setSelectedRows] = useState([]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  const handleSort = (key) => {
    setSortConfig((currentSort) => {
      if (currentSort.key === key) {
        return {
          key,
          direction:
            currentSort.direction === "ascending" ? "descending" : "ascending",
        };
      }
      return { key, direction: "ascending" };
    });
  };

  const handleSelectedRows = (rows) => {
    setSelectedRows(rows);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState([true]);
  const [error, setError] = useState([null]);

  useEffect(() => {
    refreshData();
  }, []);

  const refreshData = () => {
    fetchSenders(setData, setLoading, setError);
  };


  return (
    <div>
      <Navbar page="Senders" />
      <div className="min-h-screen bg-slate-50 p-6">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="space-y-8"
        >
          {/* Header Section */}
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold text-gray-800">
              Sender Management
            </h1>
          </div>

          {/* Stats Grid */}

          {loading ? (
            <SenderIdShimmerComponent />
          ) : error ? <LoadErrorPlaceholder/> :(
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatCard
                  title="Total Senders"
                  subtitle="Registered accounts"
                  count={data.senderStats.count_senderid}
                  change="12"
                  trend="up"
                  color="[#FF6C6C]"
                  icon=<Users className="w-6 h-6" />
                  itemVariants={itemVariants}
                />
                <StatCard
                  title="Approved"
                  subtitle="Currently verified"
                  count={data.senderStats.count_approved_senderid}
                  change="12"
                  trend="up"
                  color="green"
                  icon=<UserCheck className="w-6 h-6" />
                  itemVariants={itemVariants}
                />
                <StatCard
                  title="Pending"
                  subtitle="Awaiting Approval"
                  count={data.senderStats.count_pending_senderid}
                  change="8"
                  trend="up"
                  color="purple"
                  icon=<UserPlus className="w-6 h-6" />
                  itemVariants={itemVariants}
                />
                <StatCard
                  title="Rejected"
                  subtitle="Temporarily Blocked"
                  count={data.senderStats.count_rejected_senderid}
                  change="4"
                  trend="down"
                  color="red"
                  icon=<UserX className="w-6 h-6" />
                  itemVariants={itemVariants}
                />
              </div>

              {/* Table Section */}
              <motion.div
                variants={itemVariants}
                className="bg-white rounded-xl shadow-sm"
              >
                <div className="p-4 border-b flex flex-wrap items-center justify-between gap-4">
                  <div className="flex gap-4">
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <input
                        type="text"
                        placeholder="Search senders..."
                        className="pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <button
                      className={`flex items-center gap-2 px-4 py-2 border rounded-lg ${
                        selectedRows.length > 0
                          ? "bg-red-50 text-red-600 hover:bg-red-100 border-red-200"
                          : "bg-gray-50 text-gray-300 cursor-not-allowed"
                      }`}
                      disabled={selectedRows.length === 0}
                    >
                      Delete Selected
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-gray-50">
                      <Download className="w-5 h-5" /> Export
                    </button>
                  </div>
                </div>

                {/* Table Component */}

                <SenderTableComponent
                  data={data.senderIdData}
                  searchTerm={searchTerm}
                  sortConfig={sortConfig}
                  onSort={handleSort}
                  onSuccess={refreshData}
                  // onError={onclose}
                  onSelectedRowsChange={handleSelectedRows}
                />
              </motion.div>
            </>
          ) }
        </motion.div>
      </div>
    </div>
  );
};

// function SenderStatCard(count,title,subtitle,icon,color, change,trend) {
//     return <motion.div
//       variants={itemVariants}
//       className="relative bg-white rounded-xl shadow-sm overflow-hidden"
//     >
//       <div
//         className={`absolute top-0 left-0 w-1 h-full bg-${stat.color}`} />
//       <div className="p-6">
//         <div className="flex justify-between items-start mb-4">
//           <div className="space-y-1">
//             <p className="text-sm text-gray-500">
//               {subtitle}
//             </p>
//             <h3 className="text-lg font-semibold text-gray-900">
//               {title}
//             </h3>
//           </div>
//           <div
//             className={`p-2 rounded-lg bg-${color}-50 text-${color}`}
//           >
//             {icon}
//           </div>
//         </div>
//         <div className="flex items-baseline gap-3">
//           <span className="text-3xl font-bold text-gray-900">
//             {count}
//           </span>
//           <span
//             className={`flex items-center text-sm ${stat.trend === "up"
//                 ? "text-green-600"
//                 : "text-red-600"}`}
//           >
//             {trend === "up" ? "↑" : "↓"}{" "}
//             {Math.abs(change)}%
//           </span>
//         </div>
//       </div>
//     </motion.div>;
//   }

export default Senders;
